export const fontSize = 12
export const colorDark = '#333'
export const colorLight = '#fff'
export const borderColor = '#eee'
export const canvasFont = `${fontSize}px Roboto, "Helvetica Neue", Arial, sans-serif`

